import { useEffect, useState, useMemo } from "react";
import PageHierarchy from "../page-hierarchy/page-hierarchy";
import "./consumption-forecast.scss";
import { useDispatch, useSelector } from "react-redux";
import NewFlavorsPopup from "../new-flavors-popup/new-flavors-popup";
import DataFiltersRow, { DataFiltersRowType } from "../data-filters-row/data-filters-row";
import ForecastTable from "../forecast-table/forecast-table";
import { PlanSelectorEnum } from "../shop-management/shop-management";
import { useNavigate, useLocation } from "react-router-dom";
import { AppRoutes } from "features/authentication/types/app-routes";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import { Button } from "primereact/button";
import ForecastBoxesPopup from "../forecast-boxes-popup/forecast-boxes-popup";
import { getICForecastBoxes } from "../../productSlices";
import { refreshUserInfos } from "features/authentication/authSlices";
import { InputText } from "primereact/inputtext";
const selectedProductTemplate = (option) => {
  const name = option?.name || 'Select a Time Window';
  return (
      <div className="shop-selected">
          <div className="shop__details__name">{name}</div>
      </div>
  );
}
const optionTemplate = (option) => {
  return (
      <div className="shop">
          <div>{option.name}</div>
      </div>
  );
};
const productsOptions = [
  { name: 'Next 7 days', value: 'next_7_days' },
  { name: 'Next 15 days', value: 'next_15_days' },
  { name: 'Next month', value: 'next_month' },
];
  function generateDebugData(numEntries = 10) {
    const products = ['Vanilla', 'Chocolate', 'Strawberry', 'Mint', 'Lemon', 'Pistachio', 'Caramel'];
    const debugData = [];

    for (let i = 0; i < numEntries; i++) {
        const product = products[Math.floor(Math.random() * products.length)];
        const totalConsumption = Math.floor(Math.random() * 900) + 100; // Between 100 and 1000
        const totalPercentage = (Math.random() * 100).toFixed(2); // Between 0.1 and 100.0
        const optimal7 = Math.floor(Math.random() * 20) + 1;
        const optimal7Rounded = Math.round(optimal7 / 2) * 2; // Round to the nearest even number
        const optimal5 = Math.floor(Math.random() * 20) + 1;
        const optimal5Rounded = Math.round(optimal5 / 2) * 2;
        const optimal3 = Math.floor(Math.random() * 20) + 1;
        const optimal3Rounded = Math.round(optimal3 / 2) * 2;

        debugData.push({
            product,
            total_consumption: totalConsumption,
            total_percentage: totalPercentage,
            optimal_7_box: 'Box 7L',
            optimal_7: optimal7,
            optimal_7_rounded: optimal7Rounded,
            optimal_5_box: 'Box 5L',
            optimal_5: optimal5,
            optimal_5_rounded: optimal5Rounded,
            optimal_3_box: 'Box 3L',
            optimal_3: optimal3,
            optimal_3_rounded: optimal3Rounded,
        });
    }

    return debugData;
}
const headers = [
    { field: 'name', header: 'Product', style:'' },
    { field: 'total_liters', header: 'Total Consumption', style:'' },
    { field: 'percentage', header: '% Total', style:'' },
    { field: 'box_size', header: 'Type of boxes', style:'' },
    { field: 'optimal_7L_boxes', header: 'Optimal 7L packs/pallet', style:'' },
    { field: 'optimal_7L_boxes_rounded', header: 'Optimal 7L packs/pallet rounded', style:'' },
    { field: 'optimal_5L_boxes', header: 'Optimal 5L packs/pallet', style:'' },
    { field: 'optimal_5L_boxes_rounded', header: 'Optimal 5L packs/pallet rounded', style:'' },
    { field: 'optimal_3L_boxes', header: 'Optimal 3L packs/pallet', style:'' },
    { field: 'optimal_3L_boxes_rounded', header: 'Optimal 3L packs/pallet rounded', style:'' },
];

const ConsumptionForecast = () => {
  const dispatch: Function = useDispatch();
  const user = useSelector((state: any) => state.auth.user);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isForecastBoxesPopupOpen, setIsForecastBoxesPopupOpen] = useState(false);
  const selectedShop = useSelector((state: any) => state.user.selectedShop);
  const forecastBoxes = useSelector((state: any) => state.product.ic_forecast_boxes);
  const isStandardPlan = selectedShop?.plan === PlanSelectorEnum.STANDARD;
  const navigate = useNavigate()
  const location = useLocation()
  const userShops = user.shops;
  const shopsOptions = userShops.map((shop: any) => ({ name: shop.name, value: shop.id }));
  const [filtersSelectedShop, setFiltersSelectedShop] = useState(() => {
    const saved = localStorage.getItem('forecastSelectedShop');
    return saved ? JSON.parse(saved) : null;
  });
  const [filtersSelectedProduct, setFiltersSelectedProduct] = useState(() => {
    const saved = localStorage.getItem('forecastSelectedTimeWindow');
    return saved ? JSON.parse(saved) : null;
  });
  const [search, setSearch] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

  useEffect(() => {
    const shopEntity = user.shops.find((shop: any) => shop.id === selectedShop);
    if (shopEntity?.plan !== PlanSelectorEnum.PRO) {
      navigate(`${AppRoutes.CONSUMPTION}/product`);
    }
  }, [selectedShop, navigate]);
  const handleForecastBoxes = () => {
    if(!filtersSelectedProduct || !filtersSelectedShop) return;
    dispatch(getICForecastBoxes(filtersSelectedShop, filtersSelectedProduct))
  }
  // useEffect(() => {
  //   if(!filtersSelectedProduct || !filtersSelectedShop) return;
  //   dispatch(getICForecastBoxes(filtersSelectedShop, filtersSelectedProduct))
  // },[filtersSelectedProduct, filtersSelectedShop, user.shops])

  useEffect(() => {
    refreshUserInfos(dispatch, navigate, location)
  }, [])

  useEffect(() => {
    if (filtersSelectedShop) {
      localStorage.setItem('forecastSelectedShop', JSON.stringify(filtersSelectedShop));
    }
  }, [filtersSelectedShop]);

  useEffect(() => {
    if (filtersSelectedProduct) {
      localStorage.setItem('forecastSelectedTimeWindow', JSON.stringify(filtersSelectedProduct));
    }
  }, [filtersSelectedProduct]);

  const forecastTable = useMemo(() => {
    console.log(forecastBoxes, 'forecastBoxes')
    if(Object.keys(forecastBoxes).length === 0) return null;
    const forecastBoxesWithBoxSize = forecastBoxes.map((box: any) => ({
      ...box,
      box_size: box.optimal_3L_boxes !== 0 ? '3L' : box.optimal_5L_boxes !== 0 ? '5L' : '7L'
    }))
    return forecastBoxes.length > 0 && <div className="consumption-forecast__preview-table">
    <ForecastTable 
      objectList={forecastBoxesWithBoxSize} 
      headers={headers}
      search={search}
      setSearch={setSearch}
      showFilters={showFilters}
      setShowFilters={setShowFilters}
      selectedFilters={selectedFilters}
      setSelectedFilters={setSelectedFilters}
    />
  </div>
  }, [forecastBoxes, search, showFilters, selectedFilters])
  return (
    <div className='consumption-forecast'>
        <PageHierarchy />
        <div className="consumption-forecast__boxes-selector">
          <div className="consumption-forecast__boxes-selector__title">Update which flavor is in 3L boxes / 5L boxes / 7L boxes</div>

          <Button onClick={() => setIsForecastBoxesPopupOpen(true)} iconPos='right' label={'Update'} className="consumption-forecast__boxes-selector__button" />
        </div>
        <div className="separator"></div>
        <div className="consumption-forecast__selectors">
        <div className="forecast-data-filters-row">
          <InputText value={filtersSelectedProduct} onChange={(e) => setFiltersSelectedProduct(e.target.value)} placeholder="Number of days" type="number" max={30} min={1} />
            <Dropdown value={filtersSelectedShop} onChange={(e) => setFiltersSelectedShop(e.value)} options={shopsOptions} optionLabel="name" placeholder="Select a shop" 
                 itemTemplate={optionTemplate} filterTemplate={selectedProductTemplate} className="shop-dropdown"
                />
                <Button onClick={handleForecastBoxes} iconPos='right' label={'Forecast'} className="consumption-forecast__boxes-selector__button" />
        </div>  
        </div>
        {forecastTable}
        {isPopupOpen && (
          <NewFlavorsPopup fullCommentary="fff" isVisible={isPopupOpen} setVisible={setIsPopupOpen} />
        )}
        {isForecastBoxesPopupOpen && (
          <ForecastBoxesPopup fullCommentary="fff" isVisible={isForecastBoxesPopupOpen} setVisible={setIsForecastBoxesPopupOpen} filtersSelectedShopExternal={filtersSelectedShop} filtersSelectedProductExternal={filtersSelectedProduct}/>
        )}
    </div>
  );
};

export default ConsumptionForecast
;
